import { useCallback, useLayoutEffect } from 'react';

import { useAppContext } from '../app/Context';
import { getIsPresenting } from '../db/ppt';

const useAllRoutes = () => {
  const { setIsPresenting } = useAppContext();

  const getActiveFileView = useCallback(async () => {
    const isPresenting = await getIsPresenting();
    setIsPresenting(isPresenting);
  }, []);

  const registerActiveViewChanged = useCallback(() => {
    const activeViewHandler = async ({
      type,
      activeView,
    }: {
      type: Office.EventType.ActiveViewChanged;
      activeView: Office.ActiveView;
    }) => {
      if (type !== Office.EventType.ActiveViewChanged) return;

      if (activeView === Office.ActiveView.Edit) {
        setIsPresenting(false);
        return;
      }

      setIsPresenting(true);
    };

    Office.context.document.addHandlerAsync(Office.EventType.ActiveViewChanged, activeViewHandler, () => {});
  }, []);

  useLayoutEffect(() => {
    (async () => {
      // Get whether the current view is edit or read.
      await getActiveFileView();

      // Register for the active view changed handler.
      registerActiveViewChanged();
    })();
  }, []);
};

export default useAllRoutes;
